/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { css, jsx } from "@compiled/react";

import { N500, N800 } from "@atlaskit/theme/colors";
import { token } from "@atlaskit/tokens";

const formTitleStyles = css({
    color: token("color.background.neutral.bold.pressed", N800),
    fontFamily: token("font.family.brand.heading"),
    fontStyle: "normal",
    fontWeight: token("font.weight.medium"),
    fontSize: "36px",
    lineHeight: "44px",
    margin: 0
});

const formDescriptionStyles = css({
    color: token("color.background.neutral.bold.pressed", N500),
    fontFamily: token("font.family.brand.body"),
    fontStyle: "normal",
    fontWeight: token("font.weight.regular"),
    fontSize: "16px",
    lineHeight: "24px",
    marginBlockStart: token("space.200", "16px")
});

export interface FormHeaderProps {
    title: string;
    description: string;
}

export const FormHeader = ({ title, description }: FormHeaderProps) => {
    return (
        <div>
            <h2 css={formTitleStyles}>{title}</h2>
            <div css={formDescriptionStyles}>{description}</div>
        </div>
    );
};
